import { IconButton } from '@droplet-tech-code/core-elements/module/ui/Button';
import { Divider } from '@droplet-tech-code/core-elements/module/ui/Divider/Divider';
import { Icon, IconsId } from '@droplet-tech-code/core-elements/module/ui/Icon';
import { HStack } from '@droplet-tech-code/core-elements/module/ui/Stack';
import { AppViewProps, View } from '@droplet-tech-code/core-elements/module/ui/View';

import { AppText } from '../Text';
import { Card } from './Card';
import { PaletteCode } from '@droplet-tech-code/core-elements/module/theme';

export const CardWithHeader = (props: CardHeaderProps) => {
  const children = props.children;
  return (
    <Card {...props}>
      <View style={{ position: 'relative' }}>
        <HStack p="2.5" justify="space-between" align="center">
          <HStack align="center">
            {props.iconLeftType ? (
              <IconButton
                color="monochrome"
                icon={props.iconLeftType}
                onPress={props.iconLeftOnPress}
                iconStyle={{ justifyContent: 'flex-start' }}
              />
            ) : null}
          </HStack>
          <HStack align="center">
            {props.iconRightType ? (
              props.iconRightOnPress ? (
                <IconButton
                  color={props.iconRightColor ?? 'monochrome'}
                  icon={props.iconRightType}
                  onPress={props.iconRightOnPress}
                  iconStyle={{ justifyContent: 'flex-start' }}
                />
              ) : (
                <Icon
                  color={props.iconRightColor ?? 'monochrome'}
                  icon={props.iconRightType}
                  iconStyle={{ justifyContent: 'flex-start' }}
                />
              )
            ) : null}
            {props.rightChild ? (
              <HStack style={{ justifyContent: 'flex-end' }}>
                {props.rightChild()}
              </HStack>
            ) : null}
          </HStack>
        </HStack>
        <View
          pointerEvents="none"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <AppText.MiscTag type="heading1" style={{ fontSize: 10, lineHeight: 20 }}>
            {`${props.headerText}`}
          </AppText.MiscTag>
        </View>
      </View>
      <Divider bg="monochrome-extraLight" />
      {children}
    </Card>
  );
};

interface CardHeaderProps extends AppViewProps {
  headerText: string;
  shadingOff?: boolean;
  iconRightColor?: keyof PaletteCode;
  iconRightOnPress?: () => void;
  iconLeftOnPress?: () => void;
  iconRightType?: IconsId;
  iconLeftType?: IconsId;
  rightChild?: () => JSX.Element;
}
